// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tg-0";